import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext";
import useApi from "../../../hooks/useApi";
import formStyle from "../../../Componentes/FormComp/FormComp.module.css";

const ModalNovoAmbiente = ({ onCreated }) => {

    const { closeModal } = useModal();
    const api = useApi();

    const [ loading, setLoading ] = useState(false);

    const [ formValues, setFormValues ] = useState({
        identificador: "",
        nomeEmpresa: "",
        tipoIndustria: "",
        cidade: "",
        estado: ""
    })

    const [ logoFile, setLogoFile ] = useState(null);

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormValues(prev => ({
            ...prev,
            [name]: value.toUpperCase()
        }))

    }

    const handleLogoChange = (e) => {
        const file = e.target.files?.[0] ?? null;
        setLogoFile(file);
    };

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        try{

            setLoading(true);

            const formData = new FormData();

            formData.append("identificador", formValues.identificador);
            formData.append("nomeEmpresa", formValues.nomeEmpresa);
            formData.append("tipoIndustria", formValues.tipoIndustria);
            formData.append("cidade", formValues.cidade);
            formData.append("estado", formValues.estado);

            if (logoFile) {
                formData.append("logo", logoFile);
            }

            const { data } = await api.post("/Painel/API/ControleMedicao/CreateObra/", formData);

            console.log( data );
            closeModal();
            if (typeof onCreated === "function") {
                onCreated();
            }

        }catch(e){

            console.error(e);

        }finally{

            setLoading(false);

        }

    }

    return (
        <Overlay state={true} >
            <Modal header close={ closeModal } >
                <Formulario onSubmit={ handleSubmit } >
                    <FormComp
                        title="IDENTIFICADOR"
                        type="text"
                        name="identificador"
                        valor={formValues.identificador}
                        changeFunc={handleChange}
                        maxLength={3}
                    />
                    <FormComp
                        title="NOME EMPRESA"
                        type="text"
                        name="nomeEmpresa"
                        valor={formValues.nomeEmpresa}
                        changeFunc={handleChange}
                    />
                    <FormComp
                        title="TIPO INDUSTRIA"
                        type="text"
                        name="tipoIndustria"
                        valor={formValues.tipoIndustria}
                        changeFunc={handleChange}
                    />
                    <FormComp
                        title="CIDADE"
                        type="text"
                        name="cidade"
                        valor={formValues.cidade}
                        changeFunc={handleChange}
                    />
                    <FormComp
                        title="ESTADO"
                        type="text"
                        maxLength={2}
                        name="estado"
                        valor={formValues.estado}
                        changeFunc={handleChange}
                    />
                    <div className={formStyle.formChild}>
                        <p>LOGO DA OBRA (OPCIONAL)</p>
                        <input
                            type="file"
                            name="logo"
                            accept="image/jpeg,image/png,image/gif,image/webp"
                            onChange={handleLogoChange}
                            disabled={loading}
                        />
                        {logoFile ? (
                            <span style={{ fontSize: "0.85rem", color: "#4b5563", marginTop: "6px", display: "block" }}>
                                {logoFile.name}
                            </span>
                        ) : null}
                    </div>
                    <FormComp
                        type="submit"
                        valor={ loading ? "SALVANDO..." : "SALVAR" }
                        disabled={ loading }
                    />
                </Formulario>
            </Modal>
        </Overlay>
    )
}

export default ModalNovoAmbiente;
